import Vue, { PluginFunction, PluginObject } from 'vue'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import dateTimeFormats from '@/translations/dateTimeFormats'
import messages from '@/translations'

export type Plugins = (PluginObject<never> | PluginFunction<never> | Plugin)[]

interface Plugin {
    object: PluginObject<never> | PluginFunction<never>
    options?: any[]
}

class InstanceFactory {
  public create(plugins: Plugins, options: any, id: string = '#app', productionTip: boolean = false) {
    this.usePlugins(plugins)

    const i18n = this.useVuei18nAndGeti18n()

    this.useElementUi(i18n)

    options.i18n = i18n

    this.setProductionTip(productionTip)

    return new Vue(options).$mount(id)
  }

  private usePlugins(plugins: Plugins) {
    plugins.forEach(plugin => {
      if ((plugin as Plugin).object) {
        const options = (plugin as Plugin).options || []
        Vue.use((plugin as Plugin).object, ...options)
      } else {
        Vue.use((plugin as PluginObject<never>))
      }
    })
  }

  private useVuei18nAndGeti18n() {
    Vue.use(VueI18n)

    return new VueI18n({ locale: 'fr', messages, dateTimeFormats })
  }

  private useElementUi(i18n: any) {
    Vue.use(ElementUI, { i18n: (key: any, value: any) => i18n.t(key, value) })
  }

  private setProductionTip(isSet: boolean = false) {
    Vue.config.productionTip = isSet
  }
}

export default new InstanceFactory()
